export function addClass(el: Element, className: string) {
  el.classList.add(className);
}
